
export const get = async (
  endPoint: string,
  idToken?: string,
  params?: Record<string, string | number | boolean>,
) => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('x-app-version', '2.2.0');
  if (idToken) {
    headers.append('Authorization', `Bearer ${idToken}`);
  }

  const requestOptions: RequestInit = {
    method: 'GET',
    headers: headers,
  };

  if (params) {
    const paramStr = Object.entries(params)
      .map((value) => value.join('='))
      .join('&');
    endPoint = `${endPoint}?${paramStr}`;
  }

  try {
    const data = await fetch(endPoint, requestOptions);
    const resp = await data.json();
    return resp;
  } catch (err: unknown) {
    console.error('Error during GET request:', err);
    return null;
  }
};

export const post = async (
  endPoint: string,
  payload: unknown,
  idToken?: string,
) => {
  const headers = new Headers();

  headers.append('Content-Type', 'application/json');
  headers.append('x-app-version', '2.2.0');

  if (idToken) {
    headers.append('Authorization', `Bearer ${idToken}`);
  }
  const raw = JSON.stringify(payload || '{}');

  const requestOptions: RequestInit = {
    method: 'POST',
    headers: headers,
    body: raw,
  };

  try {
    const data = await fetch(endPoint, requestOptions);
    const resp = await data.json();
    return resp;
  } catch (err: unknown) {
    console.error('Error during POST request:', err);
    return null;
  }
};
